import { useEventListener } from "./eventHooks";
import { useCallback, useState } from "react";
export function useKeyListener(callbacks, options) {
    const callbackMap = new Map([
        ["keydown", callbacks.onKeyDown],
        ["keyup", callbacks.onKeyUp],
    ]);
    for (const eventType of ["keydown", "keyup"]) {
        const handler = callbackMap.get(eventType);
        if (handler) {
            // Ignore repeated events from holding down a key.
            const guardedHandler = (e) => {
                if (!e.repeat) {
                    handler(e);
                }
            };
            useEventListener("document", eventType, guardedHandler, options);
        }
    }
}
export function useKeyState(key, options) {
    const [isPressed, setIsPressed] = useState(false);
    useKeyListener({
        onKeyDown: useCallback((e) => {
            if (e.key === key) {
                if (options?.preventDefault) {
                    e.preventDefault();
                }
                setIsPressed(true);
            }
        }, [key, options?.preventDefault]),
        onKeyUp: useCallback((e) => {
            if (e.key === key) {
                if (options?.preventDefault) {
                    e.preventDefault();
                }
                setIsPressed(false);
            }
        }, [key, options?.preventDefault]),
    }, options);
    useEventListener("window", "blur", useCallback(() => setIsPressed(false), []), options); // Reset state on window blur to avoid stuck keys
    return isPressed;
}
//# sourceMappingURL=keyboardHooks.js.map